import { AI_API_SERVICE } from '@eggplant/api-hosts'
import { AuthenticatedDataRequest } from '@eggplant/data-request'
import type { EnvironmentResponse } from '@eggplant/types'
import type { ReactElement } from 'react'

interface Props {
  id: string
  children: (environment: EnvironmentResponse) => ReactElement
}

const GetAiEnvironmentRequest = ({
  id,
  children
}: Props) => {
  const url = `${AI_API_SERVICE}/agents/${id}`

  return (
    <AuthenticatedDataRequest
      children={children}
      method='get'
      url={url}
    />
  )
}

export default GetAiEnvironmentRequest
